export default __webpack_public_path__ + "static/logo-og-dd47bae70ddebb8264164bc36446f2a4.jpg";